module.exports = __webpack_public_path__ + "img/logo.3c5737f9.png";